export default { sha: '73ef2a55754fea358d15bb39dc9d6b85767010e6', buildNumber: 'undefined' }
